import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";

import { handleEvtClicks, getUrlParam } from "./helper";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, FormControl } from "@govtechsg/sgds-react/Form";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Button, Tooltip } from "@govtechsg/sgds-react";
import { Toast, ToastContainer } from "@govtechsg/sgds-react/Toast";

// Components
import HeaderRegComponent from "../Components/HeaderRegComponent";
import FooterComponent from "../Components/FooterComponent";

// Images
import img_onemap_attr from "../images/logo/round/omi_logo_attr@2x.png";
import infoImg from "../assets/icons/info.svg";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");

  const [showToast, setShowToast] = useState(false);

  const [toastText, _setToastText] = useState("");
  const { executeRecaptcha } = useGoogleReCaptcha();

  const showToastMessage = (_text) => {
    _setToastText(_text);

    setShowToast(true);
  };

  const ToastComponent = () => {
    return (
      <ToastContainer>
        <Toast
          className="om-warning"
          show={showToast}
          onClose={() => setShowToast(false)}
        >
          <Toast.Header>
            <img src={img_onemap_attr} className="rounded me-2" alt="OneMap" />
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>
            <small>{toastText}</small>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    );
  };

  const passwordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const confirmPasswordChange = (e) => {
    setConfirmNewPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const _email = e.target[0].value;
    const code = e.target[1].value;
    const newpasswordEntered = e.target[2].value;

    const token = await executeRecaptcha("reset");

    // console.log("AXIOS CALL", process.env.REACT_APP_RESET_PASSWORD);
    // axios.post('https://omi-gcc.smartgeo.sg/api/public/user/resetPasswordTest', {
    axios
      .post(`${process.env.REACT_APP_RESET_PASSWORD}`, {
        email: _email,
        password: newpasswordEntered,
        code: code,
        recaptchaBody: token,
      })
      .then((res) => {
        // console.log("GOT DATA", res);
        const { data, status } = res;
        const { access_token, expiry_timestamp } = data;

        if (status === 200) {
          // new handleEvtClicks('APIRegistration',{Status: 'ResetPasswordSuccess'})

          // navigate(`${process.env.REACT_APP_PUBLIC_URL}/resetpasswordsuccess`, { state: { accessToken: access_token, expiry_timestamp: expiry_timestamp }})

          // Pass the access token in router state, never in the URL, so it is
          // not captured by analytics, server logs or browser history.
          navigate("/resetpasswordsuccess", {
            state: { accessToken: access_token, expiry_timestamp: expiry_timestamp },
          });

          // window.location.href =
          //   "https://www.onemap.gov.sg/apidocs/resetpasswordsuccess?accessToken=" +
          //   access_token +
          //   "&expiry_timestamp=" +
          //   expiry_timestamp;
        }
      })
      .catch((err) => {
        // console.log("ERROR FROM  ", process.env.REACT_APP_RESET_PASSWORD, err);
        const {
          response: { status, data },
        } = err;

        if (status === 400 && data.message === "Recaptcha score is low") {
          showToastMessage(
            "Please refresh and try again or contact OneMap for support",
          );
        } else if (data.error) {
          showToastMessage(data.error);
        } else if (data.message) {
          showToastMessage(data.message);
        } else {
          showToastMessage(status + ": Please contact OneMap for assistance");
        }
      });
  };

  useEffect(() => {
    if (location && location.state && location.state.email) {
      setEmail(location.state.email);
      // console.log("DETECTED", location.state.email);
    } else {
      // Fall back to the email from the link (moved out of the URL on load)
      setEmail(getUrlParam("email"));
    }

    /*
    if(!email || email.length === 0)
    {
      navigate(`${process.env.REACT_APP_PUBLIC_URL}/forgetpassword`);
    }
    */
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Themes API, Access 100+ Thematic Layers for Location Analysis
        </title>
        <meta
          name="description"
          content="Leverage the OneMap Themes API to retrieve over 100 thematic layers provided by government agencies. Use these layers for location analysis and application development. Check theme status and access detailed theme info with easy-to-use APIs such as AED, Theatres, Child care, Dementia GTP"
        />
      </Helmet>
      <div className="om-body container-fluid">
        <HeaderRegComponent />

        <div className="om-body-content pageBase">
          {toastText && <ToastComponent />}

          <div id="om-section-title" className="om-sections row">
            <h1>Reset Password</h1>
          </div>

          <div id="om-section-confirm-info" className="om-sections row">
            <div className="row">
              <p>
                Your password must be 12 to 60 characters long. It must fulfil
                at least 3 out of the 4 conditions below
              </p>
              <div>
                <ol type="a">
                  <li>1 lower character&#40;s&#41;</li>
                  <li>1 upper character&#40;s&#41;</li>
                  <li>1 number&#40;s&#41;</li>
                  <li>
                    1 special character&#40;s&#41;
                    <br />
                    &#40;accepted special characters are
                    &#33;&#35;&#36;&#37;&#38;&#40;&#41;&#42;&#45;&#64;&#94;&#95;
                    and NO whitespaces&#41;
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <Form className="form-inline" onSubmit={handleSubmit}>
            <div
              id="om-section-confirm-credentials"
              className="om-sections row"
            >
              <div className="row">
                <Form.Group
                  className="col-md-6 mb-4"
                  controlId="email"
                  id="lettersOnlyErr"
                >
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    aria-errormessage="lettersOnlyErr"
                    defaultValue={email}
                    readOnly
                  />
                </Form.Group>

                <Form.Group className="col-md-6 mb-4" controlId="code">
                  <Form.Label>Confirmation Code</Form.Label>
                  <Tooltip content="Refer to email for Confirmation Code">
                    <img className="om-ml6" src={infoImg} alt="infoImg" />
                  </Tooltip>
                  <Form.Control
                    type="text"
                    placeholder="Confirmation Code"
                    defaultValue={code}
                    required
                  />
                  <FormControl.Feedback type="invalid">
                    *Please enter your last name
                  </FormControl.Feedback>
                </Form.Group>
              </div>

              <div className="row">
                <Form.Group className="col-md-6 mb-4" controlId="newpassword">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Set New Password"
                    aria-errormessage="lettersOnlyErr"
                    onChange={passwordChange}
                    defaultValue={newPassword}
                    required
                  />
                </Form.Group>
                <Form.Group
                  className="col-md-6 mb-4"
                  controlId="confirmnewpassword"
                >
                  <Form.Label>Confirm New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirm New Password"
                    aria-errormessage="lettersOnlyErr"
                    onChange={confirmPasswordChange}
                    defaultValue={confirmNewPassword}
                    required
                  />
                </Form.Group>
                <br />
              </div>

              <div className="row">
                <div className="inline-block text-center">
                  <Button className="om-btn-form-submit om-red" type="submit">
                    Reset Password
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>

        <FooterComponent />
      </div>
    </>
  );
};

export default ResetPassword;
